export const INITIAL_STATE = {
  data: null,
  isFetching: false,
  finish: false,
  error: false,
};

export const request = (state, action) => {
  return {
    ...state,
    isFetching: true,
  };
};

export const success = (state, action) => {
  return {
    ...state,
    data: action.data,
    finish: true,
    isFetching: false,
    error: false,
  };
};

export const failure = (state, action) => {
  return {
    ...state,
    data: action.errData,
    finish: true,
    isFetching: false,
    error: true,
  };
};

export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "REQ_CALCULATE_ITEM_REQUESTED":
      return request(state, action);
    case "REQ_CALCULATE_ITEM_SUCCEEDED":
      return success(state, action);
    case "REQ_CALCULATE_ITEM_FAILED":
      return failure(state, action);
    case "RESET":
      return INITIAL_STATE;
    default:
      return state;
  }
};
